export enum XlsxStatusesType {
  Ok,
  XLSXError,
  ServerError,
  Loading,
  None,
}

export type XlsxDuplicateError = {
  type: "duplicate";
  kind: "database" | "file";
  row: number;
  shutdown_id?: number;
  other_row?: number;
  date: string;
  region: string;
  shutdown_type: string;
};

export type XlsxValidationMessage = string | XlsxDuplicateError;

export type ResultMessageType = {
  text: Array<XlsxValidationMessage>;
  status: XlsxStatusesType;
};

export type StatusLabelInputType = {
  text_array: Array<XlsxValidationMessage>;
  status: XlsxStatusesType;
};
